/**
 * Global ApexCharts defaults.
 *
 * ApexCharts merges anything assigned to `window.Apex` into every chart it
 * creates, so this is the one place that can turn a setting off everywhere.
 * Per-chart options still win, which is why the handful of configs that set
 * `animations` explicitly were turned off alongside this.
 *
 * Why animations are off:
 *
 * Profiling app.netbaan.net showed the tab spending 33.9% of its CPU in the
 * cycle collector, with hard spikes to 97% of a core. The purple buffer was
 * reaching a median of 150,592 suspected objects per collection — roughly
 * 27,500 cycle-collectable objects created and dropped every second — and the
 * collectors were feeding each other, every CC reporting `GC_FINISHED` while
 * the major GCs reported `CC_FINISHED`.
 *
 * The churn came from svg.js, the SVG engine inside ApexCharts. An animated
 * update morphs every path and text node frame by frame for the duration of
 * the animation, and each element it creates and drops is a DOM object with a
 * JS wrapper, which is exactly what lands in the purple buffer. Charts now
 * snap to their new state instead of tweening to it.
 *
 * Import once, for the side effect, from the application entry point.
 */

declare global {
  interface Window {
    Apex?: Record<string, unknown>
  }
}

window.Apex = {
  ...(window.Apex || {}),
  chart: {
    ...((window.Apex?.chart as Record<string, unknown>) || {}),
    animations: {
      enabled: false,
      dynamicAnimation: { enabled: false },
      animateGradually: { enabled: false },
    },
  },
}

export {}
